import React from 'react';
import { BsList, BsSearch, BsUpload } from 'react-icons/bs';
import { useSteps } from '../../contexts/stepContext';
import { Title } from '../../styles/global';
import { Content } from '../BodyStep/styles';
import OperationButton from '../OperationButton';

const Instructions: React.FC = () => {
  const { handleChangeCurrentStep, setOperation } = useSteps();

  const handleSetOperationSearch = () => {
    setOperation('search');
    handleChangeCurrentStep();
  };

  const handleSetOperationUploadCSV = () => {
    setOperation('upload');
    handleChangeCurrentStep();
  };

  const handleSetOperationListPlates = () => {
    setOperation('listPlates');
    handleChangeCurrentStep();
  };

  return (
    <Content>
      <Title>Operações</Title>
      <OperationButton
        title="Carregar Arquivo CSV"
        onClick={handleSetOperationUploadCSV}
        icon={BsUpload}
      />
      <OperationButton
        title="Busca por Placa"
        onClick={handleSetOperationSearch}
        icon={BsSearch}
      />
      <OperationButton
        title="Listar Placas"
        onClick={handleSetOperationListPlates}
        icon={BsList}
      />
    </Content>
  );
};

export default Instructions;
